import { BaixaCobranca } from '../../../model/baixa-cobranca.model';
import { Injectable } from "@angular/core";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { QuestionarioAvaliacaoProjetoDTO } from 'src/app/model/questionario.model';


@Injectable({
  providedIn: 'root'
})
export class TarefaFgenergiaService extends FgiBackEndService<any> {
 
  getNewEntity() {
    return null;
  }
  protected getResourceURL(): string {
    return 'front/tarefas';
  }

  public criarQuestionario(cnpjCliente: string, esco: boolean): Observable<QuestionarioAvaliacaoProjetoDTO> {
    const params: any = {};
    params.esco = esco;

    return this.http.post(`${this.BASE_URL}/questionario/${cnpjCliente}`, {params: params}).pipe
      (catchError((e) => this.handleError(e))) as Observable<QuestionarioAvaliacaoProjetoDTO>;
  }

  public cancelarQuestionario(cnpjCliente: string): Observable<QuestionarioAvaliacaoProjetoDTO> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/questionario/${cnpjCliente}/cancelar`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  } 

  public atualizarLimiteContratacao(): Observable<number> {
    return this.http.post(`${this.BASE_URL}/limite-contratacao/`, {}).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  } 

  public buscarSaldoContaRecursosCoberturaGarantia(anoMesReferencia:string): Observable<number> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/saldo-conta-recursos-garantia/${anoMesReferencia}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }
  
}
